export const hcnDigitsOnly = (value) => String(value || "").replace(/\D/g, "").slice(0, 10);

export const formatHealthNumber = (value) => {
  const digits = hcnDigitsOnly(value);
  if (digits.length <= 4) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 4)} ${digits.slice(4)}`;
  return `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
};

export const maskHealthNumberLast3 = (value) => {
  const digits = hcnDigitsOnly(value);
  if (digits.length < 10) return value || "—";
  return `XXXX XXX ${digits.slice(7, 10)}`;
};
